module.exports = __webpack_public_path__ + "img/com.electrolux.myelx.taste.9024a7e7.webp";